module.exports = __webpack_public_path__ + "static/2021-01-06_00-40-32_UTC_1-1e1dd65fc199e091fce2b28dc4d1306c.jpg";